import { useRef, useState } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import ReviewItem from "../../organisms/lecture/reviewItem";

function ReviewSwiper({ dataList, reviewClicked }) {
  const swiperRef = useRef();

  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <>
      <div
        style={{
          position: "relative",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: "100%" }}>
          <Swiper
            onSwiper={(it) => {
              swiperRef.current = it;
            }}
            onSlideChange={(swiper) => {
              setActiveIndex(swiper.snapIndex);
            }}
            slidesPerView={2}
            spaceBetween={16}
            grabCursor={true}
            slidesPerGroup={1}
            modules={[Pagination]}
          >
            {dataList?.length > 0
              ? dataList?.map((item, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <ReviewItem data={item} reviewClicked={reviewClicked} />
                    </SwiperSlide>
                  );
                })
              : null}
          </Swiper>
        </div>

        {activeIndex >= 1 ? (
          <img
            onClick={() => swiperRef.current?.slidePrev()}
            style={{
              position: "absolute",
              cursor: "pointer",
              left: 0,
              width: 24,
              height: 24,
              top: "44%",
              transform: "translate(-50%, -50%)",
              zIndex: 10,
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)", // 그림자 추가
              objectFit: "contain", // 원본 비율 유지
              borderRadius: 999,
            }}
            src="/assets/icons/left_swiper.png"
            alt="left_swiper"
          />
        ) : null}

        <img
          onClick={() => swiperRef.current?.slideNext()}
          style={{
            position: "absolute",
            cursor: "pointer",
            right: -26,
            width: 24,
            height: 24,
            top: "44%",
            transform: "translate(-50%, -50%)",
            zIndex: 10,
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)", // 그림자 추가
            objectFit: "contain", // 원본 비율 유지
            borderRadius: 999,
          }}
          src="/assets/icons/right_swiper.png"
          alt="right_swiper"
        />
      </div>
    </>
  );
}

export default ReviewSwiper;
